export const JUMP_TO_LAST_WATCH_ENABLE_KEY = "jumpToLastWatchEnable";
export const AUTO_PLAY_KEY = "autoPlay";

export const LOCALS: {
  code: string;
  label: string;
}[] = [
  { code: "en", label: "English" },
  { code: "he", label: "עברית" },
];
